import { render, staticRenderFns } from "./PostCode.vue?vue&type=template&id=7bdc1f0c&scoped=true&"
import script from "./PostCode.vue?vue&type=script&lang=js&"
export * from "./PostCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc1f0c",
  null
  
)

export default component.exports